<main class="flex-shrink-0">
  <div class="container">
    <div class="row mt-3">
      <div class="col-md-8 blog-main" *ngIf="newsElement">
        <div class="blog-post">
          <h2 class="blog-post-title">{{newsElement.title}}</h2>
          <hr>
          <img src="{{newsElement.image}}" alt="" style="width: 100%;">
          <br>
          <p class="blog-post-meta">Опубликовано: {{newsElement.altered | date: 'dd.MM.yyyy'}}</p>
          <div class="main-text news-content" id="news-content" [innerHTML]="newsElement.description"></div>
        </div>
      </div>

      <aside class="col-md-4 blog-sidebar">
        <div (click)="redirectNewsPage(item)" class="p-4 mb-3  rounded" *ngFor="let item of allNews">
          <img src="{{item.image}}" alt="" width="100%">
          <span>{{item.published | date: 'dd.MM.yyyy'}}</span>
          <p class="mb-0">{{item.title}}</p>
        </div>
      </aside>
    </div>
  </div>
</main>

